import { render } from "./Pros.vue?vue&type=template&id=4d675e09&scoped=true"
import script from "./Pros.vue?vue&type=script&lang=js"
export * from "./Pros.vue?vue&type=script&lang=js"

import "./Pros.vue?vue&type=style&index=0&id=4d675e09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d675e09"]])

export default __exports__